import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "./ProductDetails.css";
import Slideproduct from "../Componinets/Slideproduct/Slideproduct";
import ProductDeteilsLoading from "./ProductDeteilsLoading";
import SlideProductLoading from "../Componinets/Slideproduct/SlideProductLoading";
import ProdictImages from "./Home/ProdictImages";
import ProdictInfo from "./Home/ProdictInfo";
import PageTransion from "../Componinets/PageTransion";

function ProductDetails() {
  let { id } = useParams();
  console.log(id);
  let [product, setproduct] = useState(null);
  let [Lodaing, setLoding] = useState(true);
  let [relatedProducts, setrelatedProducts] = useState([]);
  let [LodaingRelatedProducts, setLodaingRelatedProducts] = useState(true);

  useEffect(() => {
    let fetchProducts = async () => {
      try {
        let res = await fetch(`https://dummyjson.com/products/${id}`);
        let data = await res.json();
        setproduct(data);
        setLoding(false);
      } catch (error) {
        console.error(error);
      }
    };
    fetchProducts();
  }, [id]);

  useEffect(() => {
    if (!product) return;
    fetch(`https://dummyjson.com/products/category/${product.category}`)
      .then((res) => res.json())
      .then((data) => {
        setrelatedProducts(data.products);
      })
      .catch((error) => console.error(error))
      .finally(() => setLodaingRelatedProducts(false));
  }, [product?.category]);

  return (
    <PageTransion key={id}>
      <div>
        {Lodaing ? (
          <ProductDeteilsLoading />
        ) : (
          <div className="item-Detailes">
            <div className="Container">
              <ProdictImages product={product} />
              <ProdictInfo product={product} />
            </div>
          </div>
        )}

        {LodaingRelatedProducts ? (
          <SlideProductLoading />
        ) : (
          <Slideproduct
            key={product.category}
            data={relatedProducts}
            title={product.category.replace("-", " ")}
          />
        )}
      </div>
    </PageTransion>
  );
}

export default ProductDetails;
